import React, { FC, useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { KTSVG } from '../../../../_metronic/helpers';
import * as a from '../';

type Props = {
    colSpan?: number;
    className?: string;
    style?: any;
    helpText?: string;
};

export const TH: React.FC<Props> = ({ colSpan, className, style, children, helpText }) => {
    const showTooltip = helpText != undefined && helpText !== ''; // Check if helpText is not empty

    const thStyle: React.CSSProperties = showTooltip
        ? { ...style, cursor: 'pointer' } // Apply pointer cursor style if helpText is not empty
        : style;

    return (
        <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={showTooltip ? <Tooltip>{helpText}</Tooltip> : <></>} // Show Tooltip only if helpText is not empty
        >
            <th colSpan={colSpan !== undefined ? colSpan : 1} role="columnheader" style={thStyle} className={`pe-2 ${className}`}>
                {children}
            </th>
        </OverlayTrigger>
    );
};
